import { AsyncImage } from '../AsyncImg';

export function ImageGrid<Image extends { url: string }>({
  images,
  onClick,
  imageAspectRatio = '4/5',
}: {
  images: Image[];
  onClick?: (image: Image) => void;
  imageAspectRatio?: number | string;
}) {
  const handleClick = (image: Image) => {
    onClick?.(image);
  };

  return (
    <div className="d-grid grid-cols-3 gap-1 px-1">
      {images.map((image) => (
        <div
          key={image.url}
          style={{ aspectRatio: imageAspectRatio }}
          onClick={() => {
            handleClick(image);
          }}
        >
          <AsyncImage
            src={image.url}
            style={{
              display: 'block',
              height: '100%',
              width: '100%',
              objectFit: 'cover',
            }}
          />
        </div>
      ))}
    </div>
  );
}
